import React from 'react'
// import archivoListado from '../../assets/files/Concurso/CONCURSO DEPG LISTADO PROVISIONAL 2025.pdf'

const ConcursoListadoProvisional = () => {
  // const reconsideracionesForm = 'https://forms.gle/AXdzYo8NV8Fn6XWVA'

  return (
    <div className='page-section instructivos listado-provisional'>
        <section className='info-container' id='index'>
          {/* <p className='heading-p'></p> */}
          
          <div className='callout info mb-4'>
            <i class="bi bi-info-circle icon"></i>
            <p>Los resultados son temporales y podrían cambiar después del período de Reconsideraciones.</p>
          </div>

          {/* <div className='info-group column'>
            <a 
              href={archivoListado}
              download={'CONCURSO DEPG LISTADO PROVISIONAL 2025.pdf'}
              className='btn-baremo btn btn-primary link-button px-4 my-0'
            >
              Ver Listado
            </a>
          </div> */}

          <div className='info-group text-start w-100 mt-2'>
            <h3 className='page-subtitle'>Reconsideraciones</h3>

            <p className='fw-semibold'>Modalidad Virtual</p>

            <div className='list-column mb-4'>
              <p>» Miércoles 29 de Octubre</p>
              <p>» Jueves 30 de Octubre</p>
              <p>» Viernes 31 de Octubre</p>
            </div>

            {/* <a 
              href={reconsideracionesForm} 
              target='blank'
              className='btn-baremo btn btn-primary link-button px-4 my-0'
            >
              Reconsideraciones
            </a> */}
          </div>

          <div className='info-group list-column' hidden>
            <p className='name-p lead-name'>Dr. Freddy Pachano Arenas<br/>Director</p>
            <p className='name-p'>Dra. Jorymar Leal<br/>Secretaria Docente</p>
          </div>
        </section>
    </div>
  )
}

export { ConcursoListadoProvisional }